import React, { useMemo } from "react";
import { Form, InputNumber, Table } from "antd";
import { buildVariants, variantKey } from "../utils";

export default function InventoryVariantsTable({
  genders,
  sizes,
  colors,
  inventory,
  onChange,
}) {
  const variants = useMemo(() => buildVariants(genders, sizes), [genders, sizes]);

  const columns = useMemo(
    () => [
      { title: "Sexo", dataIndex: "gender", key: "gender", width: 120 },
      { title: "Talla", dataIndex: "size", key: "size", width: 80 },
      ...colors.map((color) => ({
        title: color,
        key: color,
        render: (_, { gender, size }) => {
          const key = variantKey(gender, size, color);
          return (
            <InputNumber
              min={0}
              value={inventory[key] || 0}
              onChange={(value) => onChange(key, value || 0)}
              style={{ width: "100%" }}
            />
          );
        },
      })),
    ],
    [colors, inventory, onChange]
  );

  return (
    <Form.Item label="Inventario por variante">
      <div
        style={{
          overflowX: "auto",
          border: "1px solid #f0f0f0",
          borderRadius: 8,
          padding: 12,
        }}
      >
        <Table
          bordered
          size="small"
          pagination={false}
          dataSource={variants}
          columns={columns}
          rowKey="key"
        />
      </div>
    </Form.Item>
  );
}
